/**
 * 放水记录路由
 */
const ReleaseRouter = {
  path: 'release',
  name: 'Release',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Release/index')
}
export default ReleaseRouter
